module.exports = __webpack_public_path__ + "img/29_39.ba3d323c.png";